"use client";
import SvgSentimentDissatisfiedFilled from "./sentiment_dissatisfied-filled.svg.js";
import SvgSentimentDissatisfiedOutlined from "./sentiment_dissatisfied-outlined.svg.js";
import SvgSentimentDissatisfiedRound from "./sentiment_dissatisfied-round.svg.js";
import SvgSentimentDissatisfiedSharp from "./sentiment_dissatisfied-sharp.svg.js";
import SvgSentimentNeutralFilled from "./sentiment_neutral-filled.svg.js";
import SvgSentimentNeutralOutlined from "./sentiment_neutral-outlined.svg.js";
import SvgSentimentNeutralRound from "./sentiment_neutral-round.svg.js";
import SvgSentimentNeutralSharp from "./sentiment_neutral-sharp.svg.js";
import SvgSentimentSatisfiedFilled from "./sentiment_satisfied-filled.svg.js";
import SvgSentimentSatisfiedOutlined from "./sentiment_satisfied-outlined.svg.js";
import SvgSentimentSatisfiedRound from "./sentiment_satisfied-round.svg.js";
import SvgSentimentSatisfiedSharp from "./sentiment_satisfied-sharp.svg.js";
import SvgSentimentVeryDissatisfiedFilled from "./sentiment_very_dissatisfied-filled.svg.js";
import SvgSentimentVeryDissatisfiedOutlined from "./sentiment_very_dissatisfied-outlined.svg.js";
import SvgSentimentVeryDissatisfiedRound from "./sentiment_very_dissatisfied-round.svg.js";
import SvgSentimentVeryDissatisfiedSharp from "./sentiment_very_dissatisfied-sharp.svg.js";
import SvgSentimentVerySatisfiedFilled from "./sentiment_very_satisfied-filled.svg.js";
import SvgSentimentVerySatisfiedOutlined from "./sentiment_very_satisfied-outlined.svg.js";
import SvgSentimentVerySatisfiedRound from "./sentiment_very_satisfied-round.svg.js";
import SvgSentimentVerySatisfiedSharp from "./sentiment_very_satisfied-sharp.svg.js";
const sentiment_dissatisfied = {
  filled: SvgSentimentDissatisfiedFilled,
  outlined: SvgSentimentDissatisfiedOutlined,
  round: SvgSentimentDissatisfiedRound,
  sharp: SvgSentimentDissatisfiedSharp
};
const sentiment_neutral = {
  filled: SvgSentimentNeutralFilled,
  outlined: SvgSentimentNeutralOutlined,
  round: SvgSentimentNeutralRound,
  sharp: SvgSentimentNeutralSharp
};
const sentiment_satisfied = {
  filled: SvgSentimentSatisfiedFilled,
  outlined: SvgSentimentSatisfiedOutlined,
  round: SvgSentimentSatisfiedRound,
  sharp: SvgSentimentSatisfiedSharp
};
const sentiment_very_dissatisfied = {
  filled: SvgSentimentVeryDissatisfiedFilled,
  outlined: SvgSentimentVeryDissatisfiedOutlined,
  round: SvgSentimentVeryDissatisfiedRound,
  sharp: SvgSentimentVeryDissatisfiedSharp
};
const sentiment_very_satisfied = {
  filled: SvgSentimentVerySatisfiedFilled,
  outlined: SvgSentimentVerySatisfiedOutlined,
  round: SvgSentimentVerySatisfiedRound,
  sharp: SvgSentimentVerySatisfiedSharp
};
export {
  sentiment_dissatisfied,
  sentiment_neutral,
  sentiment_satisfied,
  sentiment_very_dissatisfied,
  sentiment_very_satisfied
};
